import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';

import config from 'data/config.json';
import Button from 'UI/atoms/Button';

import styles from './styles.module.scss';

const Activity = ({ data, token, activityId }) => {
  const { t, i18n } = useTranslation();

  const zone = config.zones.find((zone) => zone.locale === i18n.language);
  const dateOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
  const dateString = (new Date(data.start_date)).toLocaleDateString(zone.dateString, dateOptions);

  return (<div className={styles.activity}>
    <p className={styles.continue}>{t('activity.continue_inscription')}</p>
    <a href={data.url} className={styles.link} target="_blank" rel="noreferrer">
      <div className={styles.imageWrapper}>
        {data.image &&
          <img className={styles.featuredImage} src={data.image} title={data.title} alt={t('activity.alt_image')} />
        }
        {data.speakers &&
          <img className={styles.speaker} src={data.speakers[0].image} title={data.speakers[0].name} alt={t('activity.alt_speaker')} />
        }
      </div>
      <div className={styles.info}>
        <p className={styles.type}>{t(`activity.type.${data.type}`)}</p>
        <p className={styles.title}>{data.title}</p>
        <div className={styles.location}>
          <p className={styles.city}><i className={styles.mapMarker} />{data.city}</p>
          <p className={styles.date}><i className={styles.calendar}></i> {dateString} <i className={styles.grayArrow}></i> {data.duration}</p>
        </div>
        {data.collaborators &&
          <ul className={styles.collaborators}>
            {data.collaborators.map((collaborator) => (
              <li key={collaborator.name}>
                <img src={collaborator.image} className={styles.collaboratorImage} title={collaborator.name} />
              </li>
            ))}
          </ul>
        }
      </div>
    </a>
    <form className={styles.form}
      action={`${process.env.REACT_APP_INSCRIPTIONS_DOMAIN}/${zone.locale}`} target="_blank">
      <input type="hidden" name="token" value={token} />
      <input type="hidden" name="idActivity" value={activityId} />
      <Button type="submit">
        {t('activity.button_continue')}
      </Button>
    </form>
  </div>);
};

Activity.propTypes = {
  data: PropTypes.object,
  token: PropTypes.string,
  activityId: PropTypes.string
};

export default Activity;
